import React from 'react'

import HelpTraitCard from './HelpTraitCard'
import { getBigFiveTraits } from './bigFiveTraitsData'

const HelpBigFiveTraits = ({ language }) => (
  <div className="HelpBigFiveTraits">
    {getBigFiveTraits(language).map(trait => (
      <HelpTraitCard key={trait.id} {...trait} />
    ))}
  </div>
)

export default HelpBigFiveTraits
